module.exports = __webpack_public_path__ + "img/direction-icon.35f57181.svg";